import { FC, PropsWithChildren, ReactElement } from 'react';

import './DialogContent.scss';

interface DialogContentProps extends PropsWithChildren {
    title?: string;
    className?: string;
    contentWrapperClassName?: string;
}

export const DialogContent: FC<DialogContentProps> = ({
    title,
    className = '',
    contentWrapperClassName = '',
    children,
}): ReactElement => (
    <div className={`dialog-content ${className}`}>
        {title && (
            <header className="dialog-content__header">
                <h1 className="dialog-content__title">
                    {title}
                </h1>
            </header>
        )}

        <div className={`dialog-content__content-wrapper ${contentWrapperClassName}`}>
            {children}
        </div>
    </div>
);
